export default __webpack_public_path__ + "static/media/no_doctor_result.b829bfc3.png";